import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useAllFromCollection } from '../../firebase/hooks';
import styles from './footer.css';

const Footer = () => {
	const [isLoading, links] = useAllFromCollection('social-links');
	return (
		<div className={`uk-flex uk-flex-center ${styles.footer}`}>
			{
				isLoading && '...'
			}
			{
				links.map((icon, idx) => (
					<span key={icon.name} className={idx === links.length - 1 ? '' : 'uk-margin-right'}>
						<a href={icon.fields.url.stringValue} target='_blank'>
							<FontAwesomeIcon icon={['fab', icon.name.split('/')[icon.name.split('/').length - 1]]} className={styles.icon} />
						</a>
					</span>
				))
			}
		</div>
	);
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js